<i-title
  [text]="
    ('details.title' | translate) +
    ': ' +
    (currentConstatation && !loading ? currentConstatation.id : '')
  "
  [hasBackIcon]="true"
  (iconClick)="back()"
  [buttons]="titleButtons"
></i-title>

<div class="details" *ngIf="form && !loading">
  <div
    class="details__buttons"
    *ngIf="currentConstatation.stateCode === 'PENDING'"
  >
    <i-button
      [text]="'global.validate' | translate"
      [styleClass]="'green'"
      [icon]="'bi bi-check-circle-fill'"
      (click)="send('validate')"
    ></i-button>

    <i-button
      [text]="'global.refuse' | translate"
      [styleClass]="'red'"
      [icon]="'bi bi-x-circle-fill'"
      (click)="send('refuse')"
    ></i-button>
  </div>

  <div
    class="details__notif details__notif--approved"
    *ngIf="currentConstatation.stateCode === 'APPROVED'"
  >
    <div>
      {{
        "details.approved"
          | translate: { date: operatorDate, operator: operatorFullName }
      }}
    </div>

    @if (
      currentConstatation &&
      currentConstatation.attachments &&
      currentConstatation.attachments.length > 0
    ) {
      <div class="details__notif__show" (click)="showFilesModal = true">
        {{ "details.show-files" | translate }}
      </div>
    }
  </div>

  <div
    class="details__notif details__notif--canceled details__notif--column"
    *ngIf="currentConstatation.stateCode === 'CANCELED'"
  >
    <div>
      {{
        "details.canceled"
          | translate: { date: operatorDate, operator: operatorFullName }
      }}
    </div>

    @if (currentConstatation.refusalReason) {
      <div class="details__notif__reason">
        {{ "details.refusal-reason.label" | translate }}:
        {{ currentConstatation.refusalReason }}
      </div>
    }
  </div>

  <div class="details__form">
    <div class="filter-list">
      <div class="filter-list__item">
        <div class="filter-list__item__label">
          {{ "details.source" | translate }}:
        </div>

        <div class="filter-list__item__label">
          {{ currentConstatation ? currentConstatation.source : "-" }}
        </div>
      </div>

      <div class="filter-list__item">
        <div class="filter-list__item__label">
          {{ "details.plate" | translate }}:
        </div>

        <input [type]="'text'" [formControl]="getControl('plate')" />
      </div>

      <div class="filter-list__item">
        <div class="filter-list__item__label">
          {{ "details.country" | translate }}:
        </div>

        <input [type]="'text'" [formControl]="getControl('plateCountryCode')" />
      </div>

      <div class="filter-list__item">
        <div class="filter-list__item__label">
          {{ "details.vehicle-type" | translate }}:
        </div>

        <input [type]="'text'" [formControl]="getControl('vehicleCategory')" />
      </div>

      <div class="filter-list__item">
        <div class="filter-list__item__label">
          {{ "details.offence-id" | translate }}:
        </div>

        <input [type]="'text'" [formControl]="getControl('offenceId')" />
      </div>

      <div class="filter-list__item">
        <div class="filter-list__item__label">
          {{ "details.offence-type" | translate }}:
        </div>

        <input [type]="'text'" [formControl]="getControl('offenceType')" />
      </div>

      <div class="filter-list__item">
        <div class="filter-list__item__label">
          {{ "details.photo-type" | translate }}:
        </div>

        <input [type]="'text'" [formControl]="getControl('photoType')" />
      </div>

      @for (device of currentConstatation.devices; track $index) {
        <div class="filter-list__item">
          <div class="filter-list__item__label">
            {{ "details.anpr" | translate }} {{ "details.camera" | translate }} {{ $index + 1 }}:
          </div>
  
          <div class="filter-list__item__label">
            {{ device.plateConfidenceGlobal + '%' }}
          </div>
        </div>
      }

      <div class="filter-list__item">
        <div class="filter-list__item__label">
          {{ "details.remark" | translate }}:
        </div>

        <input [type]="'text'" [formControl]="getControl('operatorComment')" />
      </div>
    </div>
  </div>

  @if (currentConstatation.devices.length) {
    <div class="details__preview my-4">
      <div class="details__preview__title">
        {{ 'details.preview.title' | translate }}
      </div>

      <div class="details__preview__devices">
        @for (device of currentConstatation.devices; track $index) {
          <div class="details__preview__device">
            <div class="details__preview__device__subtitle">
              {{ device.accordionTitle }}
            </div>

            <app-picture-strip
              [pictures]="getDevicePictures(device)"
              [alt]="device.accordionTitle || ''"
              (pictureClick)="openPicture($event)"
            ></app-picture-strip>
          </div>
        }
      </div>
    </div>
  }

  <i-accordion
    *ngIf="currentConstatation?.devices?.length"
    [title]="'details.cameras' | translate"
    [multiple]="true"
    [hideShowAllBtn]="false"
    (showAllChange)="showAllChange($event)"
  >
    @for (device of currentConstatation.devices; track $index) {
      <ng-template
        i-panel
        [header]="device.accordionTitle || ''"
        [showEditBtn]="false"
        (selectEmitter)="toggleAccordion(device)"
      >
        <div (click)="$event.stopPropagation()">
          <div class="details__carousel">
            <div class="details__cam-header">
              <div class="details__cam-header__title">
                {{
                  ("constatation.event-number" | translate) +
                    " : " +
                    device.eventNumber
                }}
              </div>
              <div class="details__cam-header__subtitle">
                {{
                  ("details.anpr" | translate) +
                    " : " +
                    device.plateConfidenceGlobal +
                    "%"
                }}
              </div>
            </div>

            @if (device.pictures && device.pictures.length) {
              <app-picture-strip
                [pictures]="getDevicePictures(device)"
                [alt]="device.accordionTitle || ''"
                (pictureClick)="openPicture($event)"
              ></app-picture-strip>
            } @else {
              <div class="details__no-picture">
                {{ "details.no-picture" | translate }}
              </div>
            }
          </div>

          <div class="details__locality" [ngClass]="{'details__locality--no-map': !device.longitude || !device.latitude}">
            <div class="details__locality__map" [ngClass]="{'details__locality__map--empty': !device.longitude || !device.latitude}" *ngIf="device.showMap">
              @if (device.longitude && device.latitude) {
                <i-map
                  [id]="'map-' + $index"
                  [token]="iMapToken"
                  [iPoints]="[device]"
                  [iMap]="device.iMapConfig"
                  [isNavigationEnabled]="false"
                ></i-map>
              } @else {
                <div class="details__locality__map__empty" [innerHTML]="'details.no-coord' | translate"></div>
              }
            </div>

            <div class="details__locality__address">
              <div class="filter-list">
                <div class="filter-list__item">
                  <div class="filter-list__item__label">
                    {{ "details.address" | translate }}:
                  </div>

                  <input
                    [type]="'text'"
                    [(ngModel)]="device.place"
                    [disabled]="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    }
  </i-accordion>
</div>

<div class="details__loader" *ngIf="loading">
  <i-loader></i-loader>
</div>

<!-- MODAL VISUALISATION FICHIERS -->

<i-modal
  [visible]="showFilesModal"
  [header]="{
    title: 'details.files-list' | translate,
    closable: true,
  }"
  [modalParameters]="{ isModal: true, style: { width: '40vw' } }"
  (emitterOnVisibleChange)="showFilesModal = false"
>
  @if (currentConstatation && currentConstatation.attachments) {
    @for (item of currentConstatation.attachments; track $index) {
      <i-file
        [file]="{ name: item.name ?? 'Document ' + $index, extension: 'pdf' }"
        [customAction]="getCustomAction(item.path)"
      >
      </i-file>
    }
  }
</i-modal>

<!-- MODAL VISUALISATION PHOTO (LUMINOSITÉ / ZOOM) -->

<app-picture-viewer
  [picture]="zoomedPicture"
  (closed)="zoomedPicture = null"
></app-picture-viewer>

<!-- MODAL MOTIF DE REFUS -->

<app-refusal-reason-modal
  [visible]="showRefusalModal"
  [loading]="loadingModal"
  (confirmed)="confirmRefusal($event)"
  (canceled)="showRefusalModal = false"
></app-refusal-reason-modal>
